
export default class Modal {

  constructor(options) {

    this.id = options.id;
    this.isOpen = false;
    this.beforeOpen = null;
    this.buttonClass = options.buttonClass;
    this.url = '';
    this.focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]';
    this.focusIndex = 0;
    this.options = options;

    if ( options.focusIndex ) {
      this.focusIndex = options.focusIndex;
    }

    console.log('OPS', options);

    // check to make sure the ID is a valid element
    if ( !$(`#${this.id}`).length ) {
      console.error(`OVERLAY WITH ID: ${this.id} DOES NOT EXIST ON THIS PAGE`);
    }

    if ( typeof options.beforeOpen === 'function' ) {
      this.beforeOpen = options.beforeOpen;
    }

    // attach the events
    $(this.buttonClass).click( () => this.handleOpenModal );
    $(`#${this.id} div.site__overlay`).click( () => this.handleClose );
    $(`#${this.id}`).on('transitionend', () => this.handleTransitionEnd );

    $(document).keyup( $.proxy( this.handleESCClose, this ) );

    console.log('GENERAL MODAL INIT COMPLETE', this.id);

  }

  handleTransitionEnd() {

    if ( this.isOpen ) {
      $(this).trigger('modalOpened');
    } else {
      $(this).trigger('modalClosed');
    }

  }

  handleESCClose(e) {

    if ( e.keyCode === 27 && this.isOpen ) { // escape key maps to keycode `27`
      this.handleClose(e);
    } else if ( this.isOpen ) {
      this.trapTabKey(e);
    }

  }

  handleClose(e) {

    if ( ($(e.target).hasClass('site__overlay') || $(e.target).hasClass('close__modal') || e.keyCode === 27)
      && this.isOpen ) {

      e.preventDefault();

      $('div.site__overlay').removeClass('show');
      $(`#${this.id}`).removeClass('show');

      setTimeout( () => {
        $(`#${this.id}`).css('display', '');
      }, 600);

      this.isOpen = false;

    }
  }

  handleOpenModal(e) {

    e.preventDefault();

    this.url = $(e.currentTarget).data('type');

    console.log('MODAL OPEN TYPE:', e);

    $(`#${this.id}`).css('display', 'block');

    if ( typeof this.beforeOpen === 'function' ) {
      this.beforeOpen( this.url, e.currentTarget );
    }

    setTimeout( () => {
      console.log( 'MODEL POS', this.id, -$(`#${this.id}.infoContainer` ).height() / 2 );
      $('div.site__overlay').addClass('show');
      $(`#${this.id}`).addClass('show');
      this.isOpen = true;
      this.setInitialFocusModal();
    }, 10);

  }

  trapTabKey(e) {

    // if tab or shift-tab pressed
    if ( e.which === 9 ) {

      // get list of all children elements in given object
      const o = $(`#${this.id}`).find('*');

      // get list of focusable items
      const focusableItems = o.filter(this.focusableElementsString).filter(':visible');

      // get currently focused item
      const focusedItem = jQuery(':focus');

      // get the number of focusable items
      const numberOfFocusableItems = focusableItems.length;

      // get the index of the currently focused item
      const focusedItemIndex = focusableItems.index(focusedItem);

      if (e.shiftKey) {
        // back tab
        // if focused on first item and user preses back-tab, go to the last focusable item
        if ( focusedItemIndex < 0 ) {
          e.preventDefault();
          focusableItems.get( numberOfFocusableItems - 1 ).focus();
        }

      } else if ( focusedItemIndex < 0 ) {
        // forward tab
        // if focused on the last item and user preses tab, go to the first focusable item
        e.preventDefault();
        focusableItems.get(0).focus();
      }

    }

  }

  setInitialFocusModal() {
    // get list of all children elements in given object
    const o = $(`#${this.id}`).find('*');

    // set focus to first focusable item
    o.filter(this.focusableElementsString).filter(':visible').eq(this.focusIndex).focus();
  }

}




// WEBPACK FOOTER //
// ./js/controllers/modules/Modal.js